export enum Gender {
    MALE = 'gender_male',
    FEMALE = 'gender_female'
}

export const genderMapping: any = {
    [Gender.MALE]: "Homme",
    [Gender.FEMALE]: "Femme"
};
